import * as Yup from "yup";

// Valores iniciales para el formulario de registro
export function initialValues() {
  return {
    avatar: "", // Pregunta si hay un usuario y si lo hay toma el avatar, si no, usa un string vacío
    fileAvatar: null,
    firstname: "",
    lastname: "",
    country: "España",
    address: "",
    phone: "",
    role: "free", // Valor por defecto 'user' para Cuenta Free
    email: "",
    password: "",
    repeatPassword: "",
    holded: "", // Campo opcional para Partner
    conditionsAccepted: false,
    code: "",
  };
}

// Esquema de validación con Yup
export function validationSchema(verificationSent) {
  return Yup.object({
    firstname: Yup.string().required("El nombre es obligatorio."),
    lastname: Yup.string().required("El apellido es obligatorio."),
    country: Yup.string().required("El país es obligatorio."),
    address: Yup.string(),
    phone: Yup.string().matches(/^\+?\d+$/, "Formato no válido."),
    role: Yup.string()
      .oneOf(["free"], "El rol seleccionado no es válido.")
      .required("El rol es obligatorio."),
    // Campo opcional para partner:
    holded: Yup.string(),
    email: Yup.string()
      .email("El email no es válido.")
      .required("Campo requerido."),
    password: Yup.string()
      .min(8, "La contraseña debe tener al menos 8 caracteres.")
      .required("Campo obligatorio."),
    repeatPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Las contraseñas deben ser iguales.")
      .min(8, "La contraseña debe tener al menos 8 caracteres.")
      .required("Campo obligatorio."),
    conditionsAccepted: Yup.bool()
      .oneOf([true], "Debes aceptar los términos y condiciones.")
      .required("Campo obligatorio."),
    code: Yup.string().when("verificationSent", {
      is: true,
      then: Yup.string()
        .required("Campo obligatorio para confirmar la cuenta.")
        .matches(/^[0-9]{6}$/, "El código debe ser de 6 dígitos."),
    }),
  });
}
